export const BASE_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const MARKET_ROUTE = '/market';
export const TEAM_ROUTE = '/team';
export const RM_ROUTE = '/rm';
export const SCENARIO_ONE_ROUTE = '/s1';
export const SCENARIO_TWO_ROUTE = '/s2';
export const SCENARIO_THREE_ROUTE = '/s3';
export const SCENARIO_FOUR_ROUTE = '/s4';
